<ngx-loading
  [show]="loading"
  [config]="{ backdropBorderRadius: '0px' }"
></ngx-loading>

<div class="container login">
  <div class="row">
    <div class="col-7 login-info">
      <!-- <img src="assets/img/meeting.jpg" alt="" class="login-info__back" /> -->
      <div class="login-info__social">
        <ol>
          <li><i class="bi bi-facebook"></i></li>
          <li><i class="bi bi-instagram"></i></li>
          <li><i class="bi bi-whatsapp"></i></li>
          <li><i class="bi bi-globe"></i></li>
        </ol>
      </div>
      <div class="login-info__desc">
        <img src="assets/img/logo-blanco.png" alt="" />
        <p>
          La herramienta ideal para llevar tu <br />restaurante hacia el éxito
        </p>
      </div>
    </div>
    <div class="form-cont col-md-5">
      <div class="login-form">
        <img src="assets/img/logo-naranja.png" alt="" />
        <div class="login-form__cont d-flex flex-column align-items-center">
          <h3 class="mb-md-4 mb-1 text-center font-weight-bold text-uppercase">INICIAR SESIÓN</h3>
          <form [formGroup]="myForm" (ngSubmit)="loginUser()" class="w-100">
            <div class="form-margin mb-2 ">
              <label for="exampleInputRuc"  class="form-label">RUC</label>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="bi bi-credit-card-fill"></i>
                </span>
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="idCompany"
                    name="idCompany"
                    id="exampleInputRuc"
                    [(ngModel)]="rucToCheck"
                    (change)="verifyDocument()"
                  />
                </div>
              </div>

              <div *ngIf="myForm.get('idCompany')?.errors && myForm.get('idCompany')?.dirty" class="invalid-feedback">
                Por favor ingrese su RUC.
              </div>
            </div>
            <div class="form-margin mb-2">
              <label for="exampleInputEmail1" class="form-label">Usuario</label>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="bi bi-envelope-fill"></i>
                </span>
                <div class="form-floating">
                  <input
                    type="email"
                    formControlName="useEmail"
                    class="form-control"
                    name="useEmail"
                    id="exampleInputEmail1"
                  />
                </div>
              </div>
              <div *ngIf="myForm.get('useEmail')?.errors && myForm.get('useEmail')?.dirty" class="invalid-feedback">
                Por favor ingrese su email.
              </div>
            </div>
            <div class="form-margin mb-2">
              <label for="exampleInputPassword1" class="form-label">Contraseña</label>
              <div class="input-group">
                <span class="input-group-text">
                <i class="bi bi-lock-fill"></i>
                </span>
                <div class="form-floating">
                  <input
                    type="password"
                    formControlName="password"
                    name="password"
                    class="form-control"
                    id="exampleInputPassword1"
                  />
                </div>
              </div>
              <div *ngIf="myForm.get('password')?.errors && myForm.get('password')?.dirty" class="invalid-feedback">
                Por favor ingrese su contraseña.
              </div>
            </div>
            <div class="login-form__links d-flex justify-content-between align-items-center form-margin-login mt-4">
              <a href="#" class="text-decoration-none">Olvidé mi contraseña</a>
              <button type="submit" class="btn btn-primary btn-outline-secondary btn-lg" [disabled]="myForm.invalid">INGRESAR</button>
              <a routerLink="/signup" class="text-decoration-none">Crea aquí tu cuenta</a>
            </div>
          </form>
        </div>
      </div>
      <div class="decoration"></div>
    </div>
  </div>
</div>
